/**
 * Title case utility for display-time name normalization.
 * Converts ALL CAPS, all lowercase, or mixed case to Title Case.
 * Does NOT modify stored data — apply at render time only.
 */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}
